import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useConnectWallet, useSetChain } from '@web3-onboard/react';
import { useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import Moralis from 'moralis';
import 'bootstrap/dist/js/bootstrap.js';

import MyRouts from './routers/routes';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ModalMenu from './components/Modal/ModalMenu';

import { checkUser } from './graphql/users/userMutations';
import { saveWallet } from './redux/action';
import RandomBackground from './components/common/RandomBackground';

function App() {
    const [{ wallet }] = useConnectWallet();
    const [{ connectedChain }] = useSetChain();
    const reduxDispatch = useDispatch();
    const [CheckUser] = useMutation(checkUser);

    /* -------------------- Moralis init (run once) -------------------- */
    useEffect(() => {
        Moralis.start({
            apiKey: process.env.REACT_APP_MORALIS_KEY
        });
    }, []);

    /* -------------------- Handle wallet change -------------------- */
    useEffect(() => {
        if (!wallet?.accounts?.[0]?.address) return;

        CheckUser({
            variables: {
                payload: {
                    wallet: wallet.accounts[0].address
                }
            },
            onCompleted: (data) => {
                reduxDispatch(
                    saveWallet({
                        role: data.checkUser.role,
                        walletAddress: data.checkUser.wallet,
                        wallet
                    })
                );
            }
        });
    }, [wallet?.accounts?.[0]?.address]);

    /* -------------------- Network validation (Cronos) -------------------- */
    useEffect(() => {
        if (!wallet || !connectedChain?.id) return;

        const expectedChainId =
            process.env.REACT_APP_ENVIRONMENT === 'DEV'
                ? '0x152' // Cronos Testnet
                : '0x19';  // Cronos Mainnet

        if (connectedChain.id !== expectedChainId) {
            toast.error(
                process.env.REACT_APP_ENVIRONMENT === 'DEV'
                    ? 'Please connect to Cronos Testnet'
                    : 'Please connect to Cronos Mainnet',
                {
                    position: 'bottom-right',
                    autoClose: false
                }
            );
        }
    }, [wallet, connectedChain?.id]);

    const appStyle = {
        backgroundImage: `url(${RandomBackground()})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
    };

    return (
        <div style={appStyle}>
            <Header />
            <ToastContainer />
            <MyRouts />
            <ModalMenu />
            <Footer />
        </div>
    );
}

export default App;
